<template>
  <section>
    <h3 class="primary--text"><v-icon color="primary" style="vertical-align: middle">settings</v-icon> {{ $util.isRol('ADMIN') ? 'Trámites' : 'Trámites de entidades' }}</h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :widthModal="800"
        >
          <template slot="buttons">
            <!-- <v-tooltip bottom v-if="$store.state.permissions['puntos:create']">
              <v-btn color="primary"
                @click.native.stop="openModal()"
                slot="activator">
                <v-icon>add</v-icon> {{$t('common.add') }}
              </v-btn>
              <span>{{ 'Agregar nuevo punto de atención' }}</span>
            </v-tooltip> -->
          </template>

          <template slot="form">
            <v-card-title class="headline">
              <v-icon>settings</v-icon> {{ form.id ? ' Editar pregunta frecuente' : ' Agregar pregunta frecuente' }}
              <v-spacer></v-spacer>
              <v-btn small flat icon @click.native="$store.commit('closeModal')">
                <v-icon class="red--text">cancel</v-icon>
              </v-btn>
            </v-card-title>
            <v-form
              @submit.prevent="guardarPregunta"
              v-model="validPregunta"
              ref="form"
              lazy-validation
              >
              <v-card-text class="pt-0">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs8>
                      <v-text-field
                        name="pregunta"
                        label="Pregunta"
                        id="pregunta"
                        v-model="form.pregunta"
                        autofocus
                        maxlength="500"
                        :counter="500"
                        :rules="$validate(['required'])"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs8>
                      <v-text-field
                        name="respuesta"
                        label="respuesta"
                        id="respuesta"
                        v-model="form.respuesta"
                        maxlength="500"
                        :counter="500"
                        :rules="$validate(['required'])"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs8>
                      <v-autocomplete
                        :items="tiposPrioridad"
                        v-model="form.prioridad"
                        label="Prioridad"
                        noDataText="No hay resultados"
                        :rules="$validate(['required'])"
                        required
                        ></v-autocomplete>
                    </v-flex>

                    <!-- <v-flex xs8>
                      <v-text-field
                        name="descripcion"
                        :label="$t('entity.crud.description')"
                        id="descripcion"
                        v-model="form.descripcion"
                        maxlength="500"
                        :counter="500"
                        :rules="$validate(['required'])"
                        required
                      ></v-text-field>
                    </v-flex> -->
                  </v-layout>
                </v-container>
                <!-- <log-datos :data="logDatos" v-if="logDatos"></log-datos> -->
              </v-card-text>
              <v-card-actions>
                <small class="error--text text-required">* {{$t('common.required_fields')}}</small>
                <v-spacer></v-spacer>
                <v-btn color="red" flat
                  @click.native="$store.commit('closeModal');">
                  <v-icon>close</v-icon> {{$t('common.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  type="submit"
                  :disabled="!validPregunta">
                  <v-icon>check</v-icon> {{$t('common.save') }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </template>

          <template slot="items" slot-scope="items">
            <td class="nowrap">
              <v-tooltip bottom v-if="$store.state.permissions['tramites:update']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native.stop="openModal(items.item)">
                  <v-icon>add</v-icon>
                </v-btn>
                <span>Agregar pregunta</span>
              </v-tooltip>
              <!-- <v-tooltip bottom v-if="$store.state.permissions['tramites:update']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="editItem(items.item.id, 'system/faqs', false)">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <span>Agregar pregunta</span>
              </v-tooltip> -->
              <!-- <v-tooltip bottom v-if="$store.state.permissions['usuarios:update']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="generarToken('ENTIDAD', { id_entidad: items.item.id })">
                  <v-icon>vpn_key</v-icon>
                </v-btn>
                <span>Generar token para la entidad</span>
              </v-tooltip> -->
              <v-tooltip bottom v-if="$store.state.permissions['tramites:read']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="verPreguntas(items.item.id)">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <span>Ver preguntas frecuentes</span>
              </v-tooltip>
            </td>
            <td>
              <v-tooltip bottom v-if="$store.state.permissions['tramites:update']">
                <v-switch
                  v-model="items.item.active"
                  value="ACTIVE"
                  @change="changeActive(items.item, items.item.id, 'system/faqs')"
                  hide-details
                  slot="activator"
                  color="success"></v-switch>
                <span>Activar/desactivar registro</span>
              </v-tooltip>
              <v-icon
                v-if="!$store.state.permissions['tramites:update']"
                :color="items.item.active === 'ACTIVE' ? 'success' : 'error'">
                {{ items.item.active === 'ACTIVE' ? 'check' : 'close' }}
              </v-icon>
            </td>
            <td>{{ items.item.nombre_tramite }}</td>
            <td>{{ items.item['entidad.nombre'] }}</td>
            <td>
              <v-chip label color="success" text-color="white" v-if="items.item.estado == 'ACTIVO'">
                {{ items.item.estado }}
              </v-chip>
              <v-chip label color="warning" text-color="white" v-if="items.item.estado == 'INACTIVO'">
                {{ items.item.estado }}
              </v-chip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" persistent :max-width="700">
      <v-card>
        <v-card-title class="headline">
            <v-icon>remove_red_eye</v-icon> {{ ` ${$t('faqs.list')}` }}
          <v-spacer></v-spacer>
          <v-btn flat small icon @click="dialog = false">
            <v-icon class="red--text">cancel</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="justify-between align-center mb-3" v-if="faqs.length > 0">
            <!-- <v-btn @click="mostrarTodo">Mostrar todo</v-btn> -->
            <v-btn @click="ocultarTodo">Ocultar todo</v-btn>
          </div>
          <v-expansion-panel
            v-model="panel"
            expand
          >
            <v-expansion-panel-content v-for="(item, idx) in faqs" :key="idx">
              <template v-slot:header>
                <div>
                  <strong>{{ item.pregunta }}</strong>
                  <v-tooltip bottom v-if="$store.state.permissions['tramites:update']">
                    <v-btn
                      icon
                      slot="activator"
                      @click.native.stop="editarPregunta(item)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <span>Editar pregunta</span>
                  </v-tooltip>
                </div>
              </template>
              <v-card>
                <v-card-text>
                  Respuesta: {{ item.respuesta }}<br>
                  Prioridad: {{ item.prioridad }}<br>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-flex v-if="faqs.length === 0">
            {{ 'No existen preguntas frecuentes para este tramite' }}
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="dialog = false">
            <v-icon>check</v-icon>
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import validate from '@/common/mixins/validate';
import token from '@/components/admin/modulo/mixins/token';
import LogDatos from '@/components/admin/usuario/LogDatos';
import logDatos from '@/components/admin/usuario/mixins/log-datos';
import usuario from '../usuario/mixins/usuario';
// import tramite from './mixins/tramite';

export default {
  mixins: [ crud, validate, token, logDatos, usuario ],
  created () {
    this.user = this.$storage.getUser();
    this.idEntidad = this.user.id_entidad;
    this.tramites = [];
    this.faqs = [];
    // this.recuperarTramites();
  },
  mounted () {},
  data () {
    return {
      tramites: [],
      faqs: [],
      logDatos: null,
      successAlert: false,
      graphql: false, // Definiendo el CRUD con Graphql
      url: 'system/tramites',
      urlFaqs: 'system/faqs',
      headers: [
        { text: this.$t('common.actions'), sortable: false },
        { text: this.$t('common.active'), sortable: false },
        { text: this.$t('tramites.crud.nombre_tramite'), value: 'nombre_tramite' },
        { text: this.$t('tramites.crud.entidad'), value: 'entidad.nombre' },
        { text: this.$t('common.status'), value: 'estado' }
      ],
      form: {
        pregunta: '',
        respuesta: '',
        prioridad: '',
        id_tramite: ''
      },
      tiposPrioridad: [1, 2, 3, 4, 5],
      filters: [
        {
          field: 'nombre_tramite',
          label: this.$t('tramites.crud.nombre_tramite'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'entidad',
          label: this.$t('tramites.crud.entidad'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'estado',
          label: this.$t('common.status'),
          type: 'select',
          typeG: 'EstadoEntidad',
          items: [
            { value: '', text: 'TODOS' },
            { value: 'ACTIVO', text: 'ACTIVO' },
            { value: 'INACTIVO', text: 'INACTIVO' }
          ]
        }
      ],
      idEntidad: null,
      valid: false,
      validPregunta: false,
      dialog: false,
      panel: []
    };
  },
  watch: {
    'form.pregunta': function () {
      this.validarFormFaqs();
    },
    'form.respuesta': function () {
      this.validarFormFaqs();
    },
    'form.prioridad': function () {
      this.validarFormFaqs();
    }
  },
  methods: {
    recuperarFaqs (idTramite, abrirModal = false) {
      if (idTramite) {
        this.faqs = [];
        // this.tramites = [];
        this.$service.get(`system/faqs/tramite/${idTramite}`, {})
        .then(response => {
          if (response) {
            this.faqs = response.rows;
            if (abrirModal) {
              this.dialog = true;
            }
            // response.rows.forEach((item) => {
            //   this.canales.push({id: item.id, usuario: item.usuario, clasificacion: item.clasificacion});
            // });
          }
        });
      }
    },
    openModal (tramite, pregunta = {}, form = true) {
      this.validPregunta = false;
      this.$refs.form.reset();
      this.logDatos = null;
      if (tramite.id) {
        if (pregunta && pregunta.id) {
          this.$nextTick(() => {
            this.logDatos = this.getLogDatos(tramite);
            this.form = pregunta;
          });
        } else {
          this.form = {
            pregunta: '',
            respuesta: '',
            prioridad: '',
            id_tramite: tramite.id
          };
        }
        if (form) {
          this.$store.commit('openModal');
        }
      } else {
        this.$message.error(`¡Debe seleccionar un trámite!`);
      }
    },
    guardarPregunta () {
      if (this.$refs.form.validate()) {
        let data = Object.assign({}, this.form);
        if (data.id) {
          let id = data.id;
          delete data.id;
          this.$service.put(`${this.urlFaqs}/${id}`, data)
          .then(response => {
            if (response) {
              this.$message.success(`¡Datos de pregunta actualizados!`, null, { timeout: 2000 });
              this.$store.commit('closeModal');
            }
          });
        } else {
          // data.estado = 'ACTIVO';
          this.$service.put(`${this.urlFaqs}`, data)
          .then(response => {
            if (response) {
              this.$message.success(`¡Pregunta agregada!`, null, { timeout: 2000 });
              this.$store.commit('closeModal');
            }
          });
        }
      } else {
        this.$message.error(`Corrija los datos resaltados en el formulario para poder continuar`);
      }
    },
    validarFormFaqs () {
      if (this.form && this.form.pregunta && this.form.pregunta.length > 0 && this.form.respuesta && this.form.respuesta.length > 0 && this.form.prioridad > 0) {
        this.validPregunta = true;
      } else {
        this.validPregunta = false;
      }
    },
    verPreguntas (idTramite) {
      this.recuperarFaqs(idTramite, true);
    },
    mostrarTodo () {
      this.panel = [...Array(this.faqs).keys()].map(_ => true);
    },
    ocultarTodo () {
      this.panel = [];
    },
    editarPregunta (pregunta) {
      this.validPregunta = true;
      this.$refs.form.reset();
      if (pregunta && pregunta.id && pregunta.id_tramite) {
        this.$nextTick(() => {
          this.form = pregunta;
          this.$store.commit('openModal');
        });
      }
    },
    removerOperador (item) {
      this.form.operadores_autorizados.splice(this.form.operadores_autorizados.indexOf(item), 1);
      this.form.operadores_autorizados = [...this.form.operadores_autorizados];
    },
    removerCanal (item) {
      this.form.canales_autorizados.splice(this.form.canales_autorizados.indexOf(item), 1);
      this.form.canales_autorizados = [...this.form.canales_autorizados];
    }
  },
  components: {
    CrudTable,
    LogDatos
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/tramites/Tramite.vue